import { getUUID } from "@hex-insights/core";

export { projectName, mainServerAppName, jwtIssuer } from "@hex-insights/roadium.shared";

export const appName = "portal";
export const appVersion = process.env.REACT_APP_VERSION ?? "";
export const instanceID = getUUID();
